// extracted by mini-css-extract-plugin
module.exports = {"orderHeaderDetail":"orderHeaderDetail_orderHeaderDetail__3UUYL"};